import request from '@/utils/request'


/**
 * 获取行业动态列表信息
 * @param {} data 
 * @returns 
 */
export function getList(data) {
    return request({
        baseURL: process.env.VUE_APP_Dzy,
        url: '/api/KnowledgeQuery/GetList',
        method: 'get',
        params: data
    })
}

/**
 * 
 * @param {} data 
 * @returns 
 */
 export function GetTheData(data) {
    return request({
        baseURL: process.env.VUE_APP_Dzy,
        url: '/api/Knowledge/GetTheData',
        method: 'post',
        params: data
    })
}

export function AddDownLoadvolume(data) {
    return request({
        baseURL: process.env.VUE_APP_Dzy,
        url: '/api/Knowledge/AddDownLoadvolume',
        method: 'post',
        params: data
    })
}

export function editlist(data) {
    return request({
        baseURL: process.env.VUE_APP_Dzy,
        url: '/api/Knowledge/editlist',
        method: 'post',
        data
    })
}

export function Delete(data) {
    return request({
        baseURL: process.env.VUE_APP_Dzy,
        url: '/api/Knowledge/Delete',
        method: 'post',
        params: data
    })
}

// //上传图片
// export function updateImage(data) {
//     return request({
//         baseURL: process.env.VUE_APP_Dzy,
//         url: '/api/back/aboutus/updateImage',
//         method: 'post',
//         data,
//         contentType:"multipart/form-data"
//     })
// }

//上传图片
export function updateImage(data) {
    return request({
        baseURL: process.env.VUE_APP_Dzy,
        url: '/api/Equipment/updateImage',
        method: 'post',
        data,
        contentType:"multipart/form-data"
    })
}

//上传视频
export function UploadVideo(data,fileobj) {
    return request({
        baseURL: process.env.VUE_APP_Dzy,
        url: '/API/Science/UploadVideo',
        method: 'post',
        data,
        onUploadProgress:ProgressEvent=>{
            const complete = (ProgressEvent.loaded/ProgressEvent.total*100|0)
            fileobj.onProgress({percent:complete})
        },
        contentType:"multipart/form-data",
    })
}


//获取根据文件种类获取标签
export function GetTagDataByFileKind(data) {
    return request({
        baseURL: process.env.VUE_APP_Dzy,
        url: '/api/Knowledge/GetTagDataByFileKind',
        method: 'post',
        params: data
    })
}

//获取根据知识共享ID获取标签
export function GetTagDataByID(data) {
    return request({
        baseURL: process.env.VUE_APP_Dzy,
        url: '/api/Knowledge/GetTagDataByID',
        method: 'post',
        params: data
    })
}


//获取根据知识共享ID获取相关文章
export function GetRelevantByID(data) {
    return request({
        baseURL: process.env.VUE_APP_Dzy,
        url: '/api/KnowledgeQuery/GetRelevantByID',
        method: 'get',
        params: data
    })
}

//获取根据知识共享ID获取相关文章
export function GetKnowledgeTagList(data) {
    return request({
        baseURL: process.env.VUE_APP_Dzy,
        url: '/api/KnowledgeQuery/GetKnowledgeTagList',
        method: 'get',
        params: data
    })
}




// WEBPACK FOOTER //
// ./src/api/Knowledgeapi.js